import React from "react";

export function DmsPermissions({ dms, onChange }) {
  if (!dms) return null;

  const handleCheckboxChange = (field) => {
    onChange({
      ...dms,
      [field]: !dms[field],
    });
  };

  return (
    <div className="mb-4">
      <h4 className="mb-3">Donor Management System</h4>
      <div className="row">
        <div className="col-md-6 mb-2">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="dmsCanAccess"
              checked={!!dms.canAccess}
              onChange={() => handleCheckboxChange("canAccess")}
            />
            <label className="form-check-label m-0 ms-2" htmlFor="dmsCanAccess">
              Can Access DMS
            </label>
          </div>
        </div>
        <div className="col-md-6 mb-2">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="dmsCanAcceptDonation"
              checked={!!dms.canAcceptDonation}
              onChange={() => handleCheckboxChange("canAcceptDonation")}
            />
            <label className="form-check-label m-0 ms-2" htmlFor="dmsCanAcceptDonation">
              Can Accept Donation
            </label>
          </div>
        </div>
        <div className="col-md-6 mb-2">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="dmsCanCreateDonor"
              checked={!!dms.canCreateDonor}
              onChange={() => handleCheckboxChange("canCreateDonor")}
            />
            <label className="form-check-label m-0 ms-2" htmlFor="dmsCanCreateDonor">
              Can Create Donor
            </label>
          </div>
        </div>
        <div className="col-md-6 mb-2">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="dmsCanUpdateDonor"
              checked={!!dms.canUpdateDonor}
              onChange={() => handleCheckboxChange("canUpdateDonor")}
            />
            <label className="form-check-label m-0 ms-2" htmlFor="dmsCanUpdateDonor">
              Can Update Donor
            </label>
          </div>
        </div>
        <div className="col-md-6 mb-2">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="dmsCanAccessReports"
              checked={!!dms.canAccessReports}
              onChange={() => handleCheckboxChange("canAccessReports")}
            />
            <label className="form-check-label m-0 ms-2" htmlFor="dmsCanAccessReports">
              Can Access Reports
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DmsPermissions;
